// React import removed - not needed in modern React with JSX transform
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import MainLayout from './components/layout/MainLayout';
import DashboardList from './pages/Dashboard/List';
import TravelApplicationForm from './pages/TravelApplication';

// 设置 dayjs 全局中文
dayjs.locale('zh-cn');

/**
 * 根应用组件
 * 
 * 路由配置：
 * - `/` 重定向到 `/dashboard`
 * - `/dashboard` 申请列表页
 * - `/travel/new` 新建申请
 * - `/travel/:id/edit` 编辑申请（草稿）
 * - `/travel/:id/view` 查看申请（只读）
 */
function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* 根路径重定向到 Dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          
          {/* 使用 MainLayout 的路由 */}
          <Route element={<MainLayout />}>
            {/* Dashboard 列表页 */}
            <Route path="/dashboard" element={<DashboardList />} />
            
            {/* 新建申请 */}
            <Route path="/travel/new" element={<TravelApplicationForm key="new" mode="create" />} />
            
            {/* 编辑申请 */}
            <Route path="/travel/:id/edit" element={<TravelApplicationForm key="edit" mode="edit" />} />

            {/* 查看申请 */}
            <Route path="/travel/:id/view" element={<TravelApplicationForm key="view" mode="view" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
